import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getAuthUserAccessToken } from '../_attfunc';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        getAuthUserAccessToken()
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)
